import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AppInsightsService {
    public appInsights: ApplicationInsights;
    public eventNames = {
        session: {
            start: 'App Session Start',
            deepLink: 'App Opened By Deep Link'
        },
        account: {
            conflict: 'Account - Conflict',
            error: 'Account - Error'
        },
        ads: {
            clicked: 'Ad Clicked'
        },
        coupons: {
            scanned: 'Coupon - Scanned',
            verified: 'Coupon - Verified',
            error: 'Coupon - Error'
        },
        liveStream: {
            started: 'Live Stream - Started',
            stopped: 'Live Stream - Stopped'
        },
        media: {
            pageOpen: 'Media Page - Open'
        },
        payment: {
            membership: {
                canceled: 'Membership Payment - Canceled',
                completed: 'Membership Payment - Completed',
                error: 'Membership Payment - Error',
            },
            registration: {
                completed: 'Registration Payment - Completed',
                error: 'Registration Payment - Error'
            },
            success: 'Payment Success',
            fail: 'Payment Failed',
            cancel: 'Payment Canceled'
        },
        runVideo: {
            downloaded: 'Run Video - Downloaded',
            streamed: 'Run Video - Streamed',
            invalidMembership: 'Run Video - Invalid Membership'
        },
        intervals: {
            fail: 'INTERVAL CALL FAILED'
        }
    };

    constructor() {
        this.initInsights();
        console.log('APP INSIGHTS LOADED');
    }

    logPageView(name?: string, uri?: string) { // option to call manually
        this.appInsights.trackPageView({ name, uri });
    }

    logEvent(name: string, properties?: { [key: string]: any }) {
        this.appInsights.trackEvent({ name }, properties);
    }

    logMetric(name: string, average: number, properties?: { [key: string]: any }) {
        this.appInsights.trackMetric({ name, average }, properties);
    }

    logException(exception: Error, severityLevel?: number) {
        this.appInsights.trackException({ exception , severityLevel });
    }

    logTrace(message: string, properties?: { [key: string]: any }) {
        this.appInsights.trackTrace({ message }, properties);
    }

    setUserId(userId: string) {
        this.appInsights.setAuthenticatedUserContext(userId, userId, true);
    }

    clearUserId() {
        this.appInsights.clearAuthenticatedUserContext();
    }

    private initInsights() {
        this.appInsights = new ApplicationInsights({ config: environment.appInsightsConfig });
        this.appInsights.loadAppInsights();
        this.appInsights.addTelemetryInitializer((envelope) => {
            envelope.tags['ai.cloud.role'] = environment.production ? 'NextGen - Mobile App' : 'TESTING - NextGen - Mobile App';            
        });
    }
}
